module.exports = __webpack_public_path__ + "img/donate-bg.9ed12c6b.jpeg";